var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpressLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_2695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1074 85.0009C42.1074 101.98 51.9741 116.651 66.2816 123.605L45.821 67.5446C43.3683 73.0371 42.1028 78.9856 42.1074 85.0009ZM113.957 82.8364C113.957 77.5354 112.053 73.8642 110.42 71.0068C108.245 67.4736 106.208 64.4815 106.208 60.9483C106.208 57.0053 109.198 53.335 113.41 53.335C113.6 53.335 113.781 53.3587 113.967 53.3693C106.335 46.378 96.1675 42.1094 85.0006 42.1094C70.0156 42.1094 56.832 49.7977 49.1624 61.4429C50.1688 61.4731 51.118 61.4935 51.9227 61.4935C56.4092 61.4935 63.354 60.9491 63.354 60.9491C65.6662 60.8128 65.9388 64.2089 63.6299 64.4823C63.6299 64.4823 61.3054 64.7557 58.7198 64.8912L74.3397 111.352L83.7273 83.1996L77.0437 64.8904C74.7339 64.7549 72.5458 64.4815 72.5458 64.4815C70.2344 64.346 70.5053 60.812 72.8167 60.9483C72.8167 60.9483 79.9003 61.4927 84.115 61.4927C88.6007 61.4927 95.5463 60.9483 95.5463 60.9483C97.8602 60.812 98.132 64.2081 95.8214 64.4815C95.8214 64.4815 93.4928 64.7549 90.9121 64.8904L106.413 110.999L110.69 96.7024C112.546 90.7696 113.957 86.5084 113.957 82.8364Z",
    fill: "#00749A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7523 88.7528L72.8828 126.148C76.8174 127.308 80.8979 127.896 84.9998 127.896C89.9948 127.896 94.7849 127.032 99.2436 125.465C99.124 125.278 99.0219 125.08 98.9384 124.874L85.7523 88.7528ZM122.637 64.4219C122.821 65.7882 122.926 67.2556 122.926 68.8325C122.926 73.1851 122.113 78.0781 119.664 84.1961L106.562 122.077C119.314 114.641 127.891 100.826 127.891 85.0009C127.903 77.8079 126.095 70.7289 122.637 64.4219Z",
    fill: "#00749A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0005 35C57.4309 35 35 57.4292 35 84.9987C35 112.572 57.4301 135.001 85.0005 135.001C112.569 135.001 135.003 112.572 135.003 84.9987C135.003 57.4292 112.569 35 85.0005 35ZM85.0005 132.708C58.6952 132.708 37.2926 111.306 37.2926 84.9987C37.2926 58.6943 58.6944 37.2934 85.0005 37.2934C111.305 37.2934 132.706 58.6943 132.706 84.9987C132.706 111.306 111.304 132.708 85.0005 132.708Z",
    fill: "#00749A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_2695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(35 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressLogo);
export default __webpack_public_path__ + "static/media/wordpressLogo.5f4522b06475177b46a656deef4d3e38.svg";
export { ForwardRef as ReactComponent };